<template>
  <div>
    <vue-toastr ref="toast"></vue-toastr>
    <div v-for="(level, index) in levels" :key="level.id || 'new-' + index" class="level-item">
      <div class="level-header" @click="toggleLevel(index)">
        <div class="level-header-left">
          <span>{{ level.name || `Status ${index + 1}` }}</span>
          <small v-if="level.id" class="level-id">#{{ level.id }}</small>
        </div>
        <div class="level-header-right">
          <span v-if="level.expanded" class="fa fa-chevron-up"></span>
          <span v-else class="fa fa-chevron-down"></span>
        </div>
      </div>
      <div v-if="level.expanded" class="level-details">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Name</label>
              <input v-model="level.name" class="form-control"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>
                Statusschwelle ab Anzahl Punkte
                <span class="tooltip-container">
                  <i class="fa fa-question-circle tooltip-icon"></i>
                  <span class="tooltip-text">
                    Punkteanzahl, die der Kunde erreichen muss, um diesen Status zu erreichen. Wenn hier 0 oder nichts eingetragen wird, startet der Kunde direkt mit dem ersten Status.
                  </span>
                </span>
              </label>
              <input v-model.number="level.required_points" class="form-control" min="0" type="number"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Gültigkeit (Tage)
                <span class="tooltip-container">
                  <i class="fa fa-question-circle tooltip-icon"></i>
                  <span class="tooltip-text">
                    Zeitraum, wie lange der Status nach Erreichen eingefroren wird.
                  </span>
                </span>
              </label>
              <input v-model.number="level.fixed_status_days" class="form-control" min="0" type="number"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Zeitraum für die Berechnung des Status (Tage)
                <span class="tooltip-container">
                  <i class="fa fa-question-circle tooltip-icon"></i>
                  <span class="tooltip-text">
                    Zeitraum, in dem anhand der gesammelten Punkte der Status errechnet wird, z.B. 12 Monate (365 Tage).
                  </span>
                </span>
              </label>
              <input v-model.number="level.calculation_window_days" class="form-control" min="0" type="number"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="form-group">
              <label>
                <input
                    type="checkbox"
                    v-model="level.enable_reward_points"
                />
                Einmalige Punkteausschüttung bei Erreichen des Status
              </label>
            </div>
          </div>
        </div>
        <div v-if="level.enable_reward_points">
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label>Anzahl Punkte</label>
                <input
                    v-model.number="level.reward_points"
                    class="form-control"
                    type="number"
                    min="0"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label>Gültigkeit (Tage nach Erreichen des Status)</label>
                <input
                    v-model.number="level.reward_points_available_days"
                    class="form-control"
                    type="number"
                    min="0"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- Icon Picker Column -->
          <div class="col-md-6">
            <div class="form-group">
              <label>Icon auswählen</label>
              <div class="icon-selection">
                <label>
                  <input v-model="level.iconType" type="radio" value="icon"/>
                  Icon wählen
                </label>
                <!-- Show currently selected icon, if any -->
                <div v-if="level.icon && level.iconType === 'icon'" class="selected-icon" style="margin: 8px 0;">
                  <ion-icon :name="level.icon" style="font-size: 32px;"></ion-icon>
                </div>
                <!-- Button to toggle the icon picker popover -->
                <button v-if="level.iconType === 'icon'" type="button" @click="openIconPicker(index)">
                  Icon Picker
                </button>
                <!-- Icon Picker Popover -->
                <div v-if="level.iconType === 'icon' && level.iconPickerVisible" class="icon-picker-popover">
                  <div class="icon-picker-grid">
          <span
              v-for="icon in icons"
              :key="icon"
              class="icon-picker-item"
              @click="selectIcon(index, icon)"
          >
            <ion-icon :name="icon" style="font-size: 32px; cursor: pointer;"></ion-icon>
          </span>
                  </div>
                  <button type="button" @click="closeIconPicker(index)">Cancel</button>
                </div>
              </div>
            </div>
          </div>
          <!-- SVG Upload Column -->
          <div class="col-md-6">
            <div class="form-group">
              <label>Icon für Fortschrittsbalken hinzufügen (SVG)</label>
              <div class="icon-selection">
                <label>
                  <input v-model="level.iconType" type="radio" value="svg"/>
                  SVG Datei hochladen
                </label>
                <!--                <input-->
                <!--                    :disabled="level.iconType !== 'svg'"-->
                <!--                    accept=".svg"-->
                <!--                    type="file"-->
                <!--                    @change="uploadSvg(index, $event)"-->
                <!--                />-->
              </div>
            </div>
          </div>
        </div>
        <!-- Save and Delete Buttons -->
        <button class="btn btn-w-m btn-primary" type="button" @click="saveLevel(index)">Status speichern</button>
        <button class="btn btn-w-m btn-danger" type="button" @click="deleteLevel(index)">Status löschen</button>
      </div>
    </div>
    <!-- Add Level Button -->
    <button class="btn btn-block btn-outline btn-info btn-sm mt-2" type="button" @click="addLevel">
      <i class="fa fa-plus"></i> Neuen Status hinzufügen
    </button>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import axios from "axios";

export default {
  name: "LoyaltyLevels",
  components: {VueToastr},
  props: {
    settingId: {
      type: [String, Number],
      required: true,
    }
  },
  data() {
    return {
      levels: [],
      icons: [
        "star",
        "rocket",
        "trophy",
        "ribbon",
        "medal",
        "heart",
        "happy",
        "gift",
        "flash",
        "diamond",
        "flag",
      ],
    };
  },
  mounted() {
    this.fetchLevels();
  },
  methods: {
    async fetchLevels() {
      try {
        const response = await axios.get(`/backend/loyalty-program/settings/${this.settingId}/levels`);
        this.levels = response.data.levels || response.data;
        this.levels.forEach(level => {
          level.expanded = false;
          level.iconType = level.iconType || 'icon';
          level.enable_reward_points = level.enable_reward_points ?? false;
          level.reward_points = level.reward_points ?? 0;
          level.reward_points_available_days = level.reward_points_available_days ?? 0;
        });
      } catch (error) {
        this.$refs.toast.e("Fehler beim Laden der Status.", "Fehler");
      }
    },
    toggleLevel(index) {
      let newVal = !this.levels[index].expanded;
      this.$set(this.levels[index], 'expanded', newVal);
      this.levels = [...this.levels];
    },
    addLevel() {
      this.levels.push({
        id: null, // null indicates a new level
        name: "",
        required_points: 0,
        fixed_status_days: 0,
        calculation_window_days: 365,
        enable_reward_points: false,
        reward_points: 0,
        reward_points_available_days: 0,
        icon: "",
        svgFile: null,
        expanded: true,
        iconType: "icon",
      });
    },
    async saveLevel(index) {
      const level = this.levels[index];
      const payload = {
        loyalty_setting_id: this.settingId,
        name: level.name,
        required_points: level.required_points,
        fixed_status_days: level.fixed_status_days,
        calculation_window_days: level.calculation_window_days,
        enable_reward_points: level.enable_reward_points,
        reward_points: level.reward_points,
        reward_points_available_days: level.reward_points_available_days,
        icon: level.icon,
      };
      try {
        let response;
        if (level.id) {
          // Explicitly convert the level id to a number
          const levelId = Number(level.id);
          response = await axios.put(`/backend/loyalty-program/settings/${this.settingId}/levels/${levelId}`, payload);
        } else {
          response = await axios.post(`/backend/loyalty-program/settings/${this.settingId}/levels`, payload);
          level.id = response.data.level.id;
        }
        this.$refs.toast.s("Status erfolgreich gespeichert!", "Erfolg");
        level.expanded = false;
      } catch (error) {
        console.error(error);
        this.$refs.toast.e("Fehler beim Speichern des Status.", "Fehler");
      }
    },
    async deleteLevel(index) {
      const level = this.levels[index];
      if (!level.id) {
        // Remove unsaved level locally
        this.levels.splice(index, 1);
        return;
      }
      if (!confirm("Möchten Sie diesen Status wirklich löschen?")) {
        return;
      }
      try {
        await axios.delete(`/backend/loyalty-program/settings/${this.settingId}/levels/${level.id}`);
        this.levels.splice(index, 1);
        this.$refs.toast.s("Status erfolgreich gelöscht!", "Erfolg");
      } catch (error) {
        this.$refs.toast.e("Fehler beim Löschen des Status.", "Fehler");
      }
    },
    uploadSvg(index, event) {
      const file = event.target.files[0];
      if (file) {
        this.levels[index].svgFile = file;
        // For file uploads, you might implement an API call to upload the file separately.
      }
    },
    // Icon picker methods:
    openIconPicker(index) {
      this.$set(this.levels[index], 'iconPickerVisible', true);
    },
    closeIconPicker(index) {
      this.$set(this.levels[index], 'iconPickerVisible', false);
    },
    selectIcon(index, iconName) {
      this.levels[index].icon = iconName;
      this.closeIconPicker(index);
    },
  },
};
</script>

<style scoped>
.level-item {
  border: 1px solid #e7eaec;
  margin-bottom: 10px;
  border-radius: 4px;
}

.level-header {
  background-color: #f5f5f5;
  color: #333333;
  padding: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.level-header-left {
  display: flex;
  align-items: center;
}

.level-id {
  color: #aaa;
  font-size: 0.8em;
  margin-left: 8px;
}

.level-details {
  padding: 10px;
}

.form-group {
  margin-bottom: 10px;
}

.icon-selection {
  display: flex;
  flex-direction: column;
}

/* Custom tooltip styles */
.tooltip-container {
  position: relative;
  display: inline-block;
  margin-left: 5px;
}

.tooltip-icon {
  cursor: pointer;
  color: #007bff;
}

.tooltip-text {
  position: absolute;
  top: 50%;
  left: 110%;
  transform: translateY(-50%);
  visibility: hidden;
  opacity: 0;
  background-color: #333;
  color: #fff;
  text-align: left;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  transition: opacity 0.1s ease-in-out;
  width: 200px;
  white-space: normal;
  z-index: 10;
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.tooltip-text::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent #333 transparent transparent;
}

.icon-selection {
  position: relative; /* ensures that the popover is positioned relative to this container */
}

.icon-picker-popover {
  position: absolute;
  top: 100%; /* position below the button */
  left: 0;
  z-index: 1000; /* a higher z-index to appear above the button */
  background: #fff;
  border: 1px solid #e7eaec;
  padding: 10px;
  margin-top: 5px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.icon-picker-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 150px;
  overflow-y: auto;
}

.icon-picker-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.level-id {
  color: #aaa;
  font-size: 0.8em;
  margin-left: 8px;
  display: none;
}
</style>
